import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Alert, Button, Row } from 'reactstrap'
import AutoTable from 'components/AutoTable'
import { extractExpirationInfo } from '../../../lib/util'

class UnassignedLicenseGrid extends Component {
  static propTypes = {
    licenses: PropTypes.arrayOf(PropTypes.object).isRequired,
    onSetupLicense: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      subscriptionId: null,
    }
  }
  getColumns = () => {
    const setupDataTestId = 'SETUP-DATA-TEST-ID'
    const id = this.props.subscriptionManager.subscriptions.values().next()
      .value
    const expiration = extractExpirationInfo(id, 'YYYY-MM-DD')
    const columns = [
      {
        title: 'Sku',
        fieldValue: 'sku',
      },
      {
        title: 'SkuCode',
        fieldValue: 'skuCode',
      },
      {
        title: 'Product',
        fieldValue: row => {
          const match = this.lookupSku(row.sku)
          if (match) return match.name
          return 'Invalid sku'
        },
      },
      {
        title: '',
        fieldValue: license => {
          return (
            !expiration.isExpired && (
              <Button
                data-testid={setupDataTestId}
                color="light"
                onClick={() => this.props.onSetupLicense(license)}
                size="sm"
              >
                <i className="fas fa-cogs text-primary" />
                &nbsp;Setup
              </Button>
            )
          )
        },
        headerStyle: { width: '7rem' },
        sort: false,
        filter: false,
      },
    ]
    return columns
  }

  lookupSku = sku => this.props.refData.skus.get(sku)

  render = () => {
    const { licenses } = this.props
    const columns = this.getColumns()

    return licenses.length ? (
      <Row>
        <AutoTable
          borderless
          columns={columns}
          filter
          headThemeLight
          rows={licenses}
          sort
        />
      </Row>
    ) : (
      <Alert color="success" style={{ width: '100%' }}>
        No results found
      </Alert>
    )
  }
}

const mapStateToProps = ({ refData, subscriptionManager }) => {
  return {
    refData,
    subscriptionManager,
  }
}

export default connect(mapStateToProps)(UnassignedLicenseGrid)



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/UnassignedLicenseGrid.js